import { fetchOfferingQueryFn } from './fetch-offering.query';
export const fetchTaxStatusQueryFn = async props => {
  const {
    taxSettings
  } = await fetchOfferingQueryFn(props);
  return {
    treatment: taxSettings == null ? void 0 : taxSettings.treatment
  };
};
//# sourceMappingURL=fetch-tax-status.query.js.map